<template>
  <nav
    id="navbarBlur"
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    data-scroll="true"
    :class="isAbsolute ? 'mt-4' : 'mt-4'"
  >
    <div class="px-4 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :color="color" />
      <div
        id="navbar"
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0"
        :class="isRTL ? 'px-0' : 'me-sm-4'"
      >
      </div>
      <div
        id="navbar"
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
        </div>
        <ul class="navbar-nav justify-content-end">
          <!-- Tasa de Cambio -->
          <li
            v-if="canViewExchangeRate"
            class="nav-item d-flex align-items-center dropdown"
            :class="isRTL ? 'ps-2' : 'pe-2'"
          >
            <a href="#" id="menuExchangeRate"
               class="nav-link align-content-center d-flex align-items-center align-center justify-content-center"
               data-bs-toggle="dropdown" aria-expanded="false"
               :class="[color, showMenu3 ? 'show' : '']" @click="toggleExchangeRate">
              <p class="d-flex align-items-center align-center justify-content-center">
                <i class="material-icons cursor-pointer">currency_exchange</i>
                <span class="ms-1 exchange-rate-badge" v-if="currentExchangeRate">
                  ${{ formatRate(currentExchangeRate.tasaCobro) }} / ${{ formatRate(currentExchangeRate.tasaVenta) }}
                </span>
              </p>
            </a>
            <ul class="px-3 py-3 dropdown-menu dropdown-menu-end me-sm-n4 exchange-rate-menu" 
                :class="showMenu3 ? 'show' : ''"
                style="min-width: 320px;"
                aria-labelledby="menuExchangeRate">
              <!-- Header -->
              <li class="dropdown-header d-flex justify-content-between align-items-center mb-2">
                <span class="fw-bold">
                  <i class="material-icons me-1" style="font-size: 18px;">currency_exchange</i>
                  Tasa de Cambio Actual
                </span>
              </li>
              
              <!-- Loading -->
              <li v-if="loadingExchangeRate" class="dropdown-item text-center py-3">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
              </li>
              
              <!-- Sin tasa -->
              <li v-else-if="!currentExchangeRate" class="dropdown-item text-center text-muted py-3">
                <i class="material-icons mb-2" style="font-size: 32px; opacity: 0.5;">info</i>
                <div>No hay tasa de cambio configurada</div>
                <button v-if="canEditExchangeRate" 
                        class="btn btn-sm btn-success mt-2" 
                        @click="openCreateExchangeRateModal">
                  <i class="material-icons" style="font-size: 16px;">add</i>
                  Crear Tasa
                </button>
              </li>
              
              <!-- Mostrar tasas actuales -->
              <li v-else class="dropdown-item">
                <div class="exchange-rate-display">
                  <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <span class="text-muted small">Tasa de Cobro (MXN/USD)</span>
                      <span class="fw-bold text-success">${{ formatRate(currentExchangeRate.tasaCobro) }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="text-muted small">Tasa de Venta (MXN/USD)</span>
                      <span class="fw-bold text-primary">${{ formatRate(currentExchangeRate.tasaVenta) }}</span>
                    </div>
                    <div class="text-muted small mt-2">
                      <i class="material-icons" style="font-size: 14px; vertical-align: middle;">calendar_today</i>
                      Fecha: {{ formatDate(currentExchangeRate.fecha) }}
                    </div>
                  </div>
                  
                  <!-- Botón para editar -->
                  <button v-if="canEditExchangeRate" 
                          class="btn btn-sm btn-warning w-100" 
                          @click="openEditExchangeRateModal">
                    <i class="material-icons me-1" style="font-size: 16px;">edit</i>
                    Modificar Tasas
                  </button>
                </div>
              </li>
              
              <!-- Footer -->
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li class="dropdown-item text-center">
                <router-link to="/configuracion/tasas-cambio" class="text-decoration-none">
                  <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">settings</i>
                  Ver historial completo
                </router-link>
              </li>
            </ul>
          </li>
          <li
            class="nav-item dropdown d-flex align-items-center"
            :class="isRTL ? 'ps-2' : 'pe-2'"
          >
            <a
              id="dropdownMenuButton1"
              href="#"
              class="p-0 nav-link lh-1"
              :class="[color, showMenu1 ? 'show' : '']"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showMenu1 = !showMenu1"
            ><p class="d-flex align-items-center align-center justify-content-center"><i
              class="material-icons cursor-pointer me-2">person</i><span class="menus">{{ username }}</span></p>
            </a>
            <ul
              class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4"
              :class="showMenu1 ? 'show' : ''"
              aria-labelledby="dropdownMenuButton1"
            >
              <li class="mb-2">
                <router-link :to="{ name: 'UserProfile' }"
                             class="dropdown-item border-radius-md d-flex align-center">
                  <i class="material-icons cursor-pointer me-2">account_circle</i>
                  Mi perfil
                </router-link>
              </li>
              <li class="mb-2">
                <a @click="logout" class="dropdown-item border-radius-md d-flex align-center">
                  <i class="material-icons cursor-pointer me-2">exit_to_app</i>
                  Cerrar Sesi&oacute;n
                </a>
              </li>
            </ul>
          </li>
          <li
            class="nav-item d-flex align-items-center dropdown"
            :class="isRTL ? 'ps-2' : 'pe-2'"
          >
            <a href="#" id="menuNotifications"
               class="nav-link align-content-center d-flex align-items-center align-center justify-content-center"
               data-bs-toggle="dropdown" aria-expanded="false"
               :class="[color, showMenu2 ? 'show' : '']" @click="toggleNotifications">
              <p class="d-flex align-items-center align-center justify-content-center">
                <i class="material-icons cursor-pointer"> notifications </i>
                <span class="contador text-white bg-info cursor-pointer" v-if="unreadNotificationsCount > 0">
                    {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
                  </span>
              </p>
            </a>
            <ul class="px-1 py-2 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu2 ? 'show' : ''"
                aria-labelledby="menuNotifications">
              
              <!-- Header de notificaciones -->
              <li class="dropdown-header d-flex justify-content-between align-items-center">
                <span>Notificaciones de Citas</span>
                <button v-if="unreadNotificationsCount > 0" 
                        class="btn btn-sm btn-outline-primary" 
                        @click="markAllNotificationsAsRead"
                        :disabled="loadingNotifications">
                  Marcar todas como leídas
                </button>
              </li>
              
              <!-- Loading -->
              <li v-if="loadingNotifications" class="dropdown-item text-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
              </li>
              
              <!-- Sin notificaciones -->
              <li v-else-if="notifications.length === 0" class="dropdown-item text-center text-muted">
                No hay notificaciones
              </li>
              
              <!-- Lista de notificaciones -->
              <li v-else v-for="notification in notifications" :key="notification.id" 
                  class="dropdown-item" 
                  :class="{ 'bg-light': !notification.read }"
                  @click="handleNotificationClick(notification)">
                <div class="d-flex align-items-start">
                  <div class="me-2">
                    <i class="material-icons text-primary" style="font-size: 24px;">calendar_today</i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="fw-bold">{{ notification.titulo }}</div>
                    <div class="text-muted small">{{ notification.mensaje }}</div>
                    <div class="text-muted small">
                      <i class="fas fa-clock me-1"></i>
                      {{ formatNotificationDate(notification.fechaCreacion) }}
                    </div>
                    <span class="badge bg-secondary">{{ notification.tipoServicioDisplay }}</span>
                  </div>
                  <div v-if="!notification.read" class="ms-2">
                    <div class="bg-primary rounded-circle" style="width: 8px; height: 8px;"></div>
                  </div>
                </div>
              </li>
              
              <!-- Footer -->
              <!-- Enlace a citas deshabilitado temporalmente - se gestionan por WhatsApp -->
              <!--
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li class="dropdown-item text-center">
                <router-link to="/gestion/citas" class="text-decoration-none">
                  Ver todas las citas
                </router-link>
              </li>
              -->
            </ul>
          </li>
          <li class="nav-item align-items-center ms-3"
              :class="isRTL ? 'ps-2' : 'pe-2'">
            <a
              id="iconNavbarSidenav"
              class="nav-link cursor-pointer"
              @click="toggleSidebar"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    
    <!-- Modal de Editar Tasa de Cambio -->
    <v-dialog v-model="showExchangeRateModal" max-width="500px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center bg-primary text-white">
          <span class="text-h5">
            <i class="material-icons me-2" style="font-size: 24px; vertical-align: middle;">currency_exchange</i>
            {{ editingExchangeRate ? 'Modificar' : 'Crear' }} Tasa de Cambio
          </span>
          <v-btn
            icon="mdi-close"
            variant="text"
            size="small"
            @click="showExchangeRateModal = false"
            class="text-white"
          />
        </v-card-title>
        
        <v-card-text class="pa-4">
          <div class="mb-3">
            <div class="text-muted small mb-2">
              <i class="material-icons" style="font-size: 14px; vertical-align: middle;">info</i>
              Fecha: {{ new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' }) }}
            </div>
          </div>
          
          <v-text-field
            v-model.number="exchangeRateForm.tasaCobro"
            label="Tasa de Cobro (MXN por USD) *"
            type="number"
            step="0.0001"
            variant="outlined"
            density="comfortable"
            hint="Tasa usada cuando el cliente PAGA en MXN"
            persistent-hint
            prefix="$"
            class="mb-3"
          />
          
          <v-text-field
            v-model.number="exchangeRateForm.tasaVenta"
            label="Tasa de Venta (MXN por USD) *"
            type="number"
            step="0.0001"
            variant="outlined"
            density="comfortable"
            hint="Tasa usada cuando el cliente PAGA en USD"
            persistent-hint
            prefix="$"
          />
        </v-card-text>
        
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            color="secondary"
            variant="flat"
            @click="showExchangeRateModal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="saveExchangeRate"
          >
            <i class="material-icons me-2" style="font-size: 18px; vertical-align: middle;">save</i>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </nav>
</template>


<script>
import MaterialInput from "@/components/MaterialInput.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { decodeBase64 } from "@/util";
import EmptyNotifications from "@/components/EmptyNotifications.vue";
import { Permissions } from '@/utils/permissions';

export default {
  name: "Navbar",
  components: {
    Breadcrumbs,
    MaterialInput,
    EmptyNotifications
  },
  created() {
    this.minNav;
  },
  
  async mounted() {
    await this.fetchNotifications();
    if (this.canViewExchangeRate) {
      await this.loadCurrentExchangeRate();
    }
  },
  props: {
    minNav: {
      type: Function,
      default: () => {
      }
    },
    color: {
      type: String,
      default: "text-body"
    }
  },
  data() {
    return {
      showMenu: false,
      showMenu1: false,
      showMenu2: false,
      showMenu3: false,
      username: this.$store.state.username,
      temporada: false,
      // Notificaciones de citas
      notifications: [],
      unreadNotificationsCount: 0,
      loadingNotifications: false,
      // Tasa de cambio
      currentExchangeRate: null,
      loadingExchangeRate: false,
      showExchangeRateModal: false,
      editingExchangeRate: false,
      exchangeRateForm: {
        tasaCobro: null,
        tasaVenta: null
      },
      // socket: new WebSocket(`${process.env.VUE_APP_URL_WS_NOTIFICATIONS}?user=${this.$store.state.userid}`)
    };
  },
  // mounted() {
  //   this.socket.onmessage = (data, event) => {
  //     const newNotification = JSON.parse(data.data);
  //     if (!this.$store.state.notifications.find(e => e.id === newNotification.id)) {
  //       this.$store.state.notifications = [
  //         { ...newNotification },
  //         ...this.$store.state.notifications
  //       ];
  //       this.createNotification(newNotification.title, newNotification.message);
  //     }
  //   };
  //
  //   this.socket.onopen = (evt) => {
  //   };
  // },
  computed: {
    ...mapState(["isRTL", "isAbsolute", "notificaciones"]),
    ...mapGetters(['hasPermission', 'isAdmin']),
    currentRouteName() {
      const name = this.$route.name;
      if (name === 'UserProfile') {
        return 'Perfil de usuario';
      }
      return name;
    },
    canViewExchangeRate() {
      return this.isAdmin || this.hasPermission(Permissions.SYSTEM_SETTINGS);
    },
    canEditExchangeRate() {
      return this.isAdmin || this.hasPermission(Permissions.SYSTEM_SETTINGS);
    },
    // notifications() {
    //   return this.$store.state.notifications;
    // }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    toggleSidebar() {
      this.navbarMinimize();
    },
    // createNotification(title, message) {
    //   Notification.requestPermission().then((result) => {
    //     if (result == "granted") {
    //       const notification = new Notification(title, {
    //         body: message,
    //         icon: process.env.VUE_APP_URL_IMAGE_NOTIFICATIONS,
    //         image: process.env.VUE_APP_URL_IMAGE_NOTIFICATIONS
    //       });
    //     }
    //   });
    //     },
    
    // Métodos de notificaciones de citas
    async toggleNotifications() {
      this.showMenu2 = !this.showMenu2;
      if (this.showMenu2) {
        await this.fetchNotifications();
      }
    },
    
    async fetchNotifications() {
      try {
        
        const { unreadAppointmentNotifications } = await import('@/actions');
        
        // Verificar token de autenticación
        const token = sessionStorage.getItem("token") || (() => {
          try {
            const authData = JSON.parse(sessionStorage.getItem("authData") || "{}");
            return authData.token;
          } catch {
            return null;
          }
        })();
        
        const response = await unreadAppointmentNotifications();
        
        if (response.data.errors) {
          console.error('GraphQL errors:', response.data.errors);
          response.data.errors.forEach((error, index) => {
            console.error(`Error ${index + 1}:`, error);
          });
        }
        
        if (response.data.data) {
        } else {
          console.warn('No data in GraphQL response');
        }
        
        this.notifications = response.data.data?.unreadAppointmentNotifications || [];
        this.unreadNotificationsCount = this.notifications.length;
      } catch (error) {
        console.error('=== ERROR FETCHING NOTIFICATIONS ===');
        console.error('Error:', error);
        console.error('Error message:', error.message);
        console.error('Error response:', error.response);
        console.error('Error response data:', error.response?.data);
        console.error('Error response status:', error.response?.status);
        console.error('=====================================');
      }
    },
    
    async handleNotificationClick(notification) {
      // Marcar como leída
      if (!notification.read) {
        try {
          const { markNotificationAsRead } = await import('@/actions');
          await markNotificationAsRead(notification.id);
          notification.read = true;
          this.unreadNotificationsCount = Math.max(0, this.unreadNotificationsCount - 1);
        } catch (error) {
          console.error('Error marking notification as read:', error);
        }
      }
      
      // Navegar a la vista de citas - Deshabilitado temporalmente
      // Las citas se gestionan por WhatsApp con los gestores
      // this.$router.push({
      //   name: 'GestionCitas',
      //   query: { 
      //     highlight: notification.appointment.id,
      //     showDetails: true 
      //   }
      // });
      
      // Cerrar dropdown
      this.showMenu2 = false;
    },
    
    async markAllNotificationsAsRead() {
      this.loadingNotifications = true;
      try {
        const { markAllNotificationsAsRead } = await import('@/actions');
        await markAllNotificationsAsRead();
        this.notifications.forEach(notification => {
          notification.read = true;
        });
        this.unreadNotificationsCount = 0;
      } catch (error) {
        console.error('Error marking all notifications as read:', error);
      } finally {
        this.loadingNotifications = false;
      }
    },
    
    formatNotificationDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const now = new Date();
      const diffInMinutes = Math.floor((now - date) / (1000 * 60));
      
      if (diffInMinutes < 1) return 'Hace un momento';
      if (diffInMinutes < 60) return `Hace ${diffInMinutes} min`;
      
      const diffInHours = Math.floor(diffInMinutes / 60);
      if (diffInHours < 24) return `Hace ${diffInHours}h`;
      
      const diffInDays = Math.floor(diffInHours / 24);
      if (diffInDays < 7) return `Hace ${diffInDays}d`;
      
      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    async logout() {
      // Elimina el token y limpia la sesión
      const { logout } = await import("@/actions");
      logout();
      this.$store.state.isAuth = false;
      this.$store.state.userid = null;
      this.$store.state.userSucursal = null;
      this.$store.state.username = null;
      this.$store.state.email = null;
      this.$store.state.firstName = null;
      this.$store.state.lastName = null;
      this.$store.state.rol = null;
      this.$store.Cargando = false;
      this.$router.push("/login");
    },
    
    // Métodos de tasa de cambio
    async toggleExchangeRate() {
      this.showMenu3 = !this.showMenu3;
      if (this.showMenu3) {
        await this.loadCurrentExchangeRate();
      }
    },
    
    async loadCurrentExchangeRate() {
      this.loadingExchangeRate = true;
      try {
        const { currentExchangeRate, latestExchangeRate } = await import('@/actions');
        let response = await currentExchangeRate();
        
        if (response?.data?.data?.currentExchangeRate) {
          this.currentExchangeRate = response.data.data.currentExchangeRate;
        } else if (response?.data?.currentExchangeRate) {
          this.currentExchangeRate = response.data.currentExchangeRate;
        } else {
          // Si no hay tasa para hoy, obtener la más reciente
          const latestResponse = await latestExchangeRate();
          if (latestResponse?.data?.data?.latestExchangeRate) {
            this.currentExchangeRate = latestResponse.data.data.latestExchangeRate;
          } else if (latestResponse?.data?.latestExchangeRate) {
            this.currentExchangeRate = latestResponse.data.latestExchangeRate;
          }
        }
      } catch (error) {
        console.error('Error cargando tasa de cambio:', error);
      } finally {
        this.loadingExchangeRate = false;
      }
    },
    
    openEditExchangeRateModal() {
      if (!this.currentExchangeRate) {
        this.openCreateExchangeRateModal();
        return;
      }
      this.editingExchangeRate = true;
      this.exchangeRateForm = {
        tasaCobro: parseFloat(this.currentExchangeRate.tasaCobro),
        tasaVenta: parseFloat(this.currentExchangeRate.tasaVenta)
      };
      this.showExchangeRateModal = true;
      this.showMenu3 = false;
    },
    
    openCreateExchangeRateModal() {
      this.editingExchangeRate = false;
      this.exchangeRateForm = {
        tasaCobro: null,
        tasaVenta: null
      };
      this.showExchangeRateModal = true;
      this.showMenu3 = false;
    },
    
    async saveExchangeRate() {
      if (!this.exchangeRateForm.tasaCobro || !this.exchangeRateForm.tasaVenta) {
        const { showError } = await import('@/actions');
        showError("Por favor complete ambos campos");
        return;
      }
      
      if (this.exchangeRateForm.tasaCobro <= 0 || this.exchangeRateForm.tasaVenta <= 0) {
        const { showError } = await import('@/actions');
        showError("Las tasas deben ser mayores a cero");
        return;
      }
      
      try {
        const { createExchangeRate, showSuccess, showError, me } = await import('@/actions');
        
        // Obtener usuario actual
        const userResponse = await me();
        const currentUser = userResponse?.data?.data?.me || userResponse?.data?.me;
        
        if (!currentUser || !currentUser.id) {
          showError("No se pudo obtener la información del usuario");
          return;
        }
        
        const today = new Date().toISOString().split('T')[0];
        const response = await createExchangeRate({
          fecha: today,
          tasaCobro: this.exchangeRateForm.tasaCobro,
          tasaVenta: this.exchangeRateForm.tasaVenta,
          creadoPorId: currentUser.id
        });
        
        if (response.data.data && response.data.data.createExchangeRate?.success) {
          showSuccess(`Tasa de cambio ${this.editingExchangeRate ? 'actualizada' : 'creada'} exitosamente`);
          this.showExchangeRateModal = false;
          await this.loadCurrentExchangeRate();
        } else {
          const error = response.data.data.createExchangeRate?.error || 'Error al guardar la tasa de cambio';
          showError(error);
        }
      } catch (error) {
        const { showError } = await import('@/actions');
        showError("Error al guardar la tasa de cambio");
        console.error('Error saving exchange rate:', error);
      }
    },
    
    formatRate(rate) {
      if (!rate) return '0.0000';
      return parseFloat(rate).toFixed(4);
    },
    
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  }
}
;
</script>

<style scoped>
.contador {
  margin-top: -10px;
  margin-left: -2px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: bold;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.boton-notificar {
  display: flex;
}

.temp-grande {
  display: flex;
}

.temp-pequeña {
  display: none;
}

@media (max-width: 550px) {
  .menus {
    display: none;
    margin-right: 0;
  }

  .contador {
    margin-top: -18px;
    margin-left: -15px;
  }

  .temp-grande {
    display: none;
  }

  .temp-pequeña {
    display: flex;
  }
}

.ml-auto {
  margin-left: auto !important;
}

.mr-auto {
  margin-right: auto !important;
}

.exchange-rate-badge {
  font-size: 0.75rem;
  font-weight: 600;
  color: #3A9F1D;
  white-space: nowrap;
}

.exchange-rate-menu {
  max-width: 350px;
}

.exchange-rate-display {
  padding: 0.5rem 0;
}

@media (max-width: 768px) {
  .exchange-rate-badge {
    display: none;
  }
}
</style>
